// client/src/components/individualPost/IndividualPost.jsx (MODIFIED)

import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { Context } from "../../context/Context";
import SyncLoader from "react-spinners/SyncLoader";
import './individualPost.css';

// 🚨 1. ACCEPT THE CALLBACK PROP
export default function IndividualPost({ onPostLoaded }) { 
    const location = useLocation();
    const path = location.pathname.split("/")[2];
    const { user } = useContext(Context);
    const [loading, setLoading] = useState(false);
    const [post, setPost] = useState({});
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [updateMode, setUpdateMode] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const getPost = async () => {
            try {
                const res = await axios.get(process.env.REACT_APP_BASE_URL+"/api/posts/" + path);
                
                // 🚨 2. CALL THE CALLBACK PROP WITH THE POST DATA
                if (onPostLoaded) {
                    onPostLoaded(res.data);
                }
                
                setPost(res.data);
                setLoading(false);
                setTitle(res.data.title);
                setDesc(res.data.desc);
            } catch (error) {
                console.error("Error fetching post:", error);
                setLoading(false);
            }
        };
        // 🚨 3. Add onPostLoaded to dependency array if using React 18 strict mode
        getPost();
    }, [path, onPostLoaded]); 

    const handleUpvote = async () => {
        const newVote = {
            post: post._id,
            user: user._id,
            type: true
        };
        try{
            const res = await axios.post(process.env.REACT_APP_BASE_URL+`/api/posts/upvote`, newVote);
        } catch (err){
            // console.log(err);
        }
    }

    const handleDelete = async () => {
        try {
        await axios.delete(process.env.REACT_APP_BASE_URL+`/api/posts/${post._id}`, {
            data: { username: user.username },
        });
        navigate("/"); // Use navigate instead of window.location.replace
        } catch (err) {}
    };

    const handleUpdate = async () => {
        try {
            await axios.put(process.env.REACT_APP_BASE_URL+`/api/posts/${post._id}`, {
                user: user._id,
                title,
                desc,
            });
            setUpdateMode(false)
        } catch (err) {}
    };

    return (
        <>
            { loading ? 
                (
                    <div className="loader">  
                        <SyncLoader
                            color={"#ffa000"}
                            loading={loading}
                            size={25}
                            margin={5}
                        />
                    </div>
                ) : (
                    <div>        
                        <div className="indPostWrapper">
                            { post.photo &&    
                                <img
                                    className="indPostImg"
                                    src={ post.photo }
                                    alt=""
                                />
                            }
                            { updateMode ? (
                                <input
                                    type="text"
                                    value={title}
                                    className="indPostTitleInput"
                                    autoFocus
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            ) : (
                                <h1 className="indPostTitle">
                                    { title }
                                    {user && post.user ? post.user._id === user._id && (
                                    <div className="indPostEdit">
                                        <i
                                            className="indPostIcon far fa-edit"
                                            onClick={() => setUpdateMode(true)}
                                        ></i>
                                        <i
                                        className="indPostIcon far fa-trash-alt"
                                        onClick={handleDelete}
                                        ></i>
                                    </div>
                                    ):""}
                                </h1>
                            )}
                            <div className="indPostInfo">
                                <span>
                                    Author:
                                    <b className="indPostAuthor">
                                        <Link className="link" to={`/profile/${post.username}`}>
                                            { post.user ? post.user.fullname : post.username }
                                        </Link>
                                    </b> | {post.votes?post.votes.length +" Votes":""} {user?(<button onClick={handleUpvote}>Upvote</button>):""}
                                </span>
                                <span>{ new Date(post.createdAt).toDateString() }</span>
                            </div>
                            {updateMode ? (
                                <textarea
                                    className="indPostDescInput"
                                    value={desc}
                                    onChange={(e) => setDesc(e.target.value)}
                                />
                                ) : (
                                    <p className="indPostDesc">{desc}</p>
                                )}
                                {updateMode && (
                                <button className="indPostButton" onClick={handleUpdate}>
                                    Update
                                </button>
                            )}
                        </div>
                    </div>
                )
            }
        </>
    )
}